Postlogin = (function (my) {
    my.LessonsProgressReport = {};
    const me = my.LessonsProgressReport;

    me.$reportResultsTable = $('#report-results-table');
    me.reportSelectOption = $('#report-select').find('option[value="LessonsProgressReport"]');
    me.reportUrl = me.reportSelectOption.data('report-url');
    me.exportUrl = me.reportSelectOption.data('report-export-url');
    me.assignmentUrl = me.reportSelectOption.data('assignment-url');

    me.filters = [
        'user-license-ids',
        'search-date',
        'lessons',
        'assigned-by',
        'subtitle',
        'user-grades',
        'completion-status',
        'user-groups-single',
    ];

    me.setup = function () {
        $('.filter-column').each((index, element) => {
            const thisFilter = $(element);
            if (me.filters.includes(thisFilter.data('filter-name'))) {
                thisFilter.removeClass('hide');
            } else {
                thisFilter.addClass('hide');
            }
        });

        $('.search-date').find('.help-block').text('Limits the results for the assignment dates.');
        me.initEvents();

        me.$reportResultsTable.bootstrapTable('destroy');
        $('#report-toolbar').hide();
    };

    me.runReport = function () {
        me.$reportResultsTable.addClass('sorting');
        $('body').css('cursor', 'progress');

        me.$reportResultsTable.bootstrapTable('destroy');
        me.$reportResultsTable.bootstrapTable(me.tableOptions);

        $('#report-toolbar').show();
    };

    me.exportReport = function () {
        const opts = $('#report-results-table').bootstrapTable('getOptions');
        const exportParams = me.getReportParams({
            columns: _.map($('#report-results-table').bootstrapTable('getVisibleColumns'), (col) => [col.title, col.field]),
            offset: 0,
            sort: opts.sortName,
            order: opts.sortOrder,
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        });

        const queryString = $.param(exportParams);
        window.open(`${me.exportUrl}?${queryString}`, '_blank');
    };

    me.initEvents = function () {
        // Ported from bootstrap-select to Tom Select 2026-05-12.
        // Mirror of lessonsOverviewReport / lessonsInterestByUsersReport:
        // destroy + recreate per tab render, plus "click optgroup
        // header → select all its options" UX rewired onto
        // Tom Select's .optgroup-header / .optgroup DOM.
        const lessonsEl = document.getElementById('lessons');
        if (!lessonsEl) return;

        if (lessonsEl.tomselect) {
            lessonsEl.tomselect.destroy();
        }
        $(lessonsEl).val('');

        const tom = new TomSelect(lessonsEl, {
            placeholder: 'All Lessons',
            plugins: ['remove_button'],
            diacritics: true,
            maxOptions: null,
            onDropdownOpen() {
                const headers = this.dropdown_content.querySelectorAll(
                    '.optgroup-header:not([data-group-toggle])',
                );
                headers.forEach((header) => {
                    header.setAttribute('data-group-toggle', '1');
                    header.style.cursor = 'pointer';
                    header.addEventListener('click', () => {
                        const group = header.parentElement;
                        if (!group) return;
                        group.querySelectorAll('.option').forEach((opt) => {
                            const value = opt.getAttribute('data-value');
                            if (value) tom.addItem(value, true);
                        });
                    });
                });
            },
        });
    };

    me.progressBars = [];
    me.setupProgressBars = function () {
        if ($('.progress-indicator').length) {
            $('.progress-indicator').each(function () {
                const progress = $(this).attr('data-progress');
                const progressId = $(this).attr('data-progress-id');
                const indicatorBar = new ProgressBar.Line(`#${$(this).attr('id')}`, {
                    strokeWidth: 3,
                    easing: 'easeInOut',
                    duration: 1400,
                    color: '#000',
                    trailColor: '#d9d9d9',
                    trailWidth: 3,
                    svgStyle: { width: '100%', height: '100%' },
                    from: { color: '#CDCD00' },
                    to: { color: '#1A9D5A' },
                    step(state, progressBar) {
                        progressBar.path.setAttribute('stroke', state.color);
                        progressBar.setText(`${Math.round(progressBar.value() * 100)} %`);
                    },
                });
                indicatorBar.animate(progress / 100); // Value from 0.0 to 1.0
                me.progressBars[progressId] = indicatorBar;
            });
        }
    };

    me.getReportParams = function (params) {
        const searchParams = _.extend({}, params);
        searchParams.license_ids = $('#user-license-ids').val();
        searchParams.date = $('#search-date option:selected').val();
        searchParams.date_range_from = $('#search-start-date').val();
        searchParams.date_range_to = $('#search-end-date').val();
        searchParams.user_grades = $('#user-grades').val();
        searchParams.lesson_ids = $('#lessons').val();
        searchParams.lesson_subtitle = $('#subtitle').val();
        searchParams.assigned_by = $('#assigned-by').val();
        searchParams.completion_status = $('#completion-status').val();
        searchParams.group_id = $('#user-groups-single').val();

        return searchParams;
    };

    me.tableOptions = _.extend({}, Jr.reportsDataTable.options, {
        idField: 'user_id',
        url: me.reportUrl,
        toolbar: '#report-toolbar',
        queryParamsType: '',
        queryParams: (params) => me.getReportParams(params),

        onColumnSwitch() {
            me.setupProgressBars();
        },

        onLoadSuccess(data) {
            $('time.timeago').timeago();
            me.$reportResultsTable.removeClass('sorting');
            me.$reportResultsTable.closest('.bootstrap-table').find('.pagination-detail .duration').remove();
            me.$reportResultsTable
                .closest('.bootstrap-table')
                .find('.pagination-detail')
                .append(`<span class="duration">&nbsp;&nbsp;&nbsp;<em>(query took ${data.duration.toFixed(4)} seconds)</em></span>`);

            $('body').css('cursor', 'default');
            $('.app').removeClass('light-blur');
            $('#ajax-progress-indicator').fadeOut();

            me.setupProgressBars();
        },

        columns: [
            {
                title: 'Date Assigned',
                field: 'date_assigned',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter(value) {
                    if (value) {
                        return new Date(value).toLocaleDateString('en-us');
                    }

                    return '-';
                },
            },
            {
                title: 'Lesson Name',
                field: 'lesson_name',
                align: 'center',
                valign: 'middle',
                sortable: true,
                visible: true,
                formatter(value, row) {
                    let lessonsViewUrl = me.assignmentUrl.replace(':lesson_id', row.lesson.lesson_id);
                    lessonsViewUrl = lessonsViewUrl.replace(':assignment_id', row.assignment_id);

                    return `<a href="${lessonsViewUrl}">${value}</a>`;
                },
            },
            {
                title: 'Grade',
                field: 'grade_band',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter: (row) => {
                    if (parseInt(row, 10) === 0) {
                        return 'K';
                    }
                    if (parseInt(row, 10) === -1) {
                        return 'PK';
                    }
                    return row;
                },
            },
            {
                title: 'Completion Type',
                field: 'completion_type',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Subtitle',
                field: 'subtitle',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Assigned By',
                field: 'assigned_by',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Assigned To',
                field: 'assigned_to',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Progress',
                field: 'progress',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter(value, row, index) {
                    return `<div class="progress-indicator hidden-print" id="student-progress-${index}" data-progress="${value}"
                            data-progress-id="${index}"></div> <span class="visible-print">${value}%</span>`;
                },
            },
            {
                title: 'Date Started',
                field: 'date_started',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter(value) {
                    return value ? new Date(value).toLocaleDateString('en-us') : '-';
                },
            },
            {
                title: 'Date Last Access',
                field: 'date_last_access',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter(value) {
                    return value ? new Date(value).toLocaleDateString('en-us') : '-';
                },
            },
            {
                title: 'Date Completed',
                field: 'date_completed',
                align: 'center',
                valign: 'middle',
                sortable: true,
                formatter(value) {
                    return value ? new Date(value).toLocaleDateString('en-us') : '-';
                },
            },
            {
                title: 'Total Time Spent',
                field: 'time_spent',
                align: 'center',
                valign: 'middle',
                sortable: true,
            },
        ],
    });

    return my;
}(Postlogin));
